const mimeTypes = ["image/gif"];

export function validate(file) {
  const ext = file.name.split(".").pop();
  if (file.type === "" && ext === "gif") {
    return true;
  }
  if (mimeTypes.indexOf(file.type) >= 0) {
    return true;
  }
  return false;
}

export function getUploadMimeType() {
  return "image/gif";
}